import './index.styl';
import template from './index.jst';
import { TradePlayerPoolFilters } from "../../Fantasy";
// import { sizes_for_big_ad } from '../../../../../core/utils';
import { AdvertisingView } from '../../index';

export class StatsCentrePlayerPoolFilters extends TradePlayerPoolFilters {
	get template(){
		return template;
	}

	regions() {
		return {
			ad_item: '#ad-item',
		};
	}

	init(args) {
		super.init(args);
		if (!this.getRegion('ad_item').hasView()) {
			this.getRegion('ad_item').show(new AdvertisingView( {
				ad_id: 'div-gpt-ad-1607993981643-0',
				ad_path: 'stats-centre',
				size: [[728, 90], [160, 600], [970, 250]],
				pos: 1,
			} ));
		}

	}

	getFilterByPriceOptions() {
		return [
			{ key: '', value: 'By Price' },
			{ key: '800-99999', value: '800k+' },
			{ key: '600-800', value: '600-800k' },
			{ key: '400-600', value: '400-600k' },
			{ key: '300-400', value: '300-400k' },
			{ key: '0-300', value: '0-300k' },
		];
	}
}

export default StatsCentrePlayerPoolFilters;